import PropTypes from "prop-types";
import "./SummaryCards.css";
import { formatCurrency } from "../../utils/utils";

const SummaryCard = ({ label, value, subValue }) => {
  return (
    <div className="summary-card">
      <div className="summary-card__label">{label}</div>
      <div className="summary-card__value">
        {value}
        {subValue ? (
          <span className="summary-card__subvalue">{subValue}</span>
        ) : null}
      </div>
    </div>
  );
};

SummaryCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  subValue: PropTypes.string,
};

const SummaryCards = ({
  availableBalance,
  currency,
  threshold,
  dueBooking,
  disputedBookingAmount,
  feeImpact,
}) => {
  return (
    <div className="summary-cards">
      <SummaryCard
        label="Available Balance"
        value={formatCurrency(availableBalance, currency)}
      />
      <SummaryCard
        label="Disputed Booking"
        value={formatCurrency(disputedBookingAmount || 0, currency)}
        subValue={`(Fee impact: ${formatCurrency(feeImpact || 0, currency)})`}
      />
      <SummaryCard
        label="Threshold"
        value={formatCurrency(threshold, currency)}
      />
      <SummaryCard
        label="Due Booking (Next 7 Days)"
        value={formatCurrency(dueBooking, currency)}
      />
    </div>
  );
};

SummaryCards.propTypes = {
  availableBalance: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  threshold: PropTypes.string.isRequired,
  dueBooking: PropTypes.string.isRequired,
  disputedBookingAmount: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  feeImpact: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default SummaryCards;
